<template>
  <div>
    <van-nav-bar :title="isAddMode ? '新增项目' : '编辑项目'" left-text="返回" @click-left="back" fixed left-arrow />
    <div class="content">
        <van-form ref="projectSubmit">
        <van-field v-model="projectDetail.projectCode" label="项目编号" :disabled="!isAddMode && !editCodeAndName"></van-field>
        <van-field v-model="projectDetail.projectName" label="项目名称" :disabled="!isAddMode && !editCodeAndName" required :rules="[{ required: true, message: '请填写项目名称' }]"></van-field>
        <!-- 主项目 -->
        <van-field label="主项目" :disabled="!isAddMode && canOnlyModParticipator"  @click="(!isAddMode && !canOnlyModParticipator) || isAddMode ? mainProjectShow = true:''" readonly clickable v-if="user.timeType.mainProjectState == '1'">
            <template #input>
                <span>{{projectDetail.projectMainName}}</span>
            </template>
        </van-field>
            <van-popup v-model="mainProjectShow" position="bottom">
                <van-picker
                show-toolbar
                value-key="name"
                :columns="mainProjectList"
                @confirm="mainProjectConfirm"
                @cancel="mainProjectShow = false"
                ></van-picker>
            </van-popup>
        <!-- 项目分类 -->
        <van-field label="项目分类" :disabled="!isAddMode && canOnlyModParticipator" @click="(!isAddMode && !canOnlyModParticipator) || isAddMode ? categoryShow = true:''" readonly clickable v-if="user.timeType.mainProjectState != '1'">
            <template #input>
                <span>{{projectDetail.categoryName}}</span>
            </template>
        </van-field>
            <van-popup v-model="categoryShow" position="bottom">
                <van-picker
                show-toolbar
                value-key="name"
                :columns="categoryList"
                @confirm="categoryConfirm"
                @cancel="categoryShow = false"
                ></van-picker>
            </van-popup>
        <!-- 项目描述 -->
        <van-field v-model="projectDetail.projectDesc" :disabled="!isAddMode && canOnlyModParticipator" label="项目描述"></van-field>
        <!-- 项目类型 -->
        <van-field label="项目类型" :disabled="!isAddMode && canOnlyModParticipator" @click="(!isAddMode && !canOnlyModParticipator) || isAddMode ? publicShow = true:''" readonly clickable>
            <template #input>
                <span>{{publicList[projectDetail.isPublic]}}</span>
            </template>
        </van-field>
            <van-popup v-model="publicShow" position="bottom">
                <van-picker
                show-toolbar
                :columns="publicList"
                @confirm="publicConfirm"
                @cancel="publicShow = false"
                ></van-picker>
            </van-popup>
        <!-- 项目级别 -->
        <van-field label="项目级别" :disabled="!isAddMode && canOnlyModParticipator" @click="(!isAddMode && !canOnlyModParticipator) || isAddMode ? levelShow = true:''" readonly clickable>
            <template #input>
                <span>{{projectDetail.levelLabel}}</span>
            </template>
        </van-field>
            <van-popup v-model="levelShow" position="bottom">
                <van-picker
                show-toolbar
                value-key="label"
                :columns="levelList"
                @confirm="levelConfirm"
                @cancel="levelShow = false"
                ></van-picker>
            </van-popup>
        
        <!-- 参与人 -->
        <van-field label="全部参与人" @click="userNamesShow = true" readonly clickable v-show="projectDetail.isPublic == 0">
            <template #input>
                <span v-if="!projectDetail.userNames"></span>
                <span v-else-if="user.userNameNeedTranslate == '1'">
                    <span v-for="item,index in projectDetail.userNames.split(',')" :key="item">
                        <TranslationOpenDataText type='userName' :openid='item'></TranslationOpenDataText>
                        <span v-if="index != (projectDetail.userNames.split(',').length - 1)">,</span>
                    </span>
                </span>
                <span v-else>{{projectDetail.userNames}}</span>
            </template>
        </van-field>
            <van-popup v-model="userNamesShow" position="bottom" :style="{ height: '80%' }" >
                <van-search v-model="userName" placeholder="输入员工姓名搜索" @search="onSearch"></van-search>
                <div style="minHeight:300px;">
                <template v-if="user.userNameNeedTranslate == '1'">
                    <van-checkbox class="userCheckbox" v-for="(item) in userList" :key="item.id" v-model="item.isChecked" ><TranslationOpenDataText type='userName' :openid='item.name'></TranslationOpenDataText></van-checkbox>
                </template>
                <template v-else>
                    <van-checkbox class="userCheckbox" v-for="(item) in userList" :key="item.id" v-model="item.isChecked" >{{item.name}}</van-checkbox>
                </template>
                <van-button style="width:100%;position: -webkit-sticky;position: sticky;bottom: 0;" @click="userNamesConfirm();userNamesShow=false">确定</van-button>
                </div>
            </van-popup>
        <!-- 项目经理 -->
        <van-field label="项目经理" @click="(isAddMode || (editProjectMan && !canOnlyModParticipator)) ? inchargerShow = true : ''" readonly clickable :disabled="!isAddMode && (!editProjectMan || canOnlyModParticipator)">
            <template #input>
                <span v-if="user.userNameNeedTranslate == '1'"><TranslationOpenDataText type='userName' :openid='projectDetail.inchargerName'></TranslationOpenDataText></span>
                <span v-else>{{projectDetail.inchargerName}}</span>
            </template>
        </van-field>
            <van-popup v-model="inchargerShow" position="bottom">
                <van-picker
                show-toolbar
                value-key="name"
                :columns="inchargerList"
                @confirm="inchargerConfirm"
                @cancel="inchargerShow = false"
                >
                <template #option="item">
                    <span v-if="user.userNameNeedTranslate == '1'"><TranslationOpenDataText type='userName' :openid='item.name'></TranslationOpenDataText></span>
                    <span v-else>{{item.name}}</span>
                </template>
                </van-picker>
            </van-popup>
        <!-- 日报审核人 -->
        <van-field label="日报审核人" :disabled="!isAddMode && canOnlyModParticipator"  readonly clickable @click="(!isAddMode && !canOnlyModParticipator) || isAddMode ? dailyReviewFlg = true:''" v-if="user.timeType.reportAuditType == 0 || user.timeType.reportAuditType == 4">
            <template #input>
                <span v-if="projectDetail.auditorList && projectDetail.auditorList.length > 0">
                    <span v-for="(items, indexs) in projectDetail.auditorList" :key="indexs">
                        <span v-if="user.userNameNeedTranslate != '1'">{{items.auditorName}}</span>
                        <span v-if="user.userNameNeedTranslate == '1'"><TranslationOpenDataText type='userName' :openid='items.auditorName'></TranslationOpenDataText></span>
                        <span v-if="projectDetail.auditorList.length - 1 > indexs">,</span>
                    </span>
                </span>
                <span v-else>-</span>
            </template>
        </van-field>
            <van-popup v-model="dailyReviewFlg" position="bottom" :style="{ height: '80%' }">
                <van-search v-model="userName" placeholder="输入员工姓名搜索" @search="onSearch"></van-search>
                <div style="minHeight:300px;">
                <template v-if="user.userNameNeedTranslate == '1'">
                    <van-checkbox class="userCheckbox" v-for="(item) in dailyUserList" :key="item.id" v-model="item.isChecked" ><TranslationOpenDataText type='userName' :openid='item.name'></TranslationOpenDataText></van-checkbox>
                </template>
                <template v-else>
                    <van-checkbox class="userCheckbox" v-for="(item) in dailyUserList" :key="item.id" v-model="item.isChecked" >{{item.name}}</van-checkbox>
                </template>
                <van-button style="width:100%;position: -webkit-sticky;position: sticky;bottom: 0;" @click="auditorNameConfirm(),dailyReviewFlg=false">确定</van-button>
                </div>
            </van-popup>
        <!-- 开始日期 -->
        <van-field label="计划开始日期" @click="(isAddMode || !canOnlyModParticipator) ? startDateShow = true:''" readonly clickable :disabled="!isAddMode && canOnlyModParticipator">
            <template #input>
                <span>{{projectDetail.planStartDate}}</span>
            </template>
        </van-field>
            <van-popup v-model="startDateShow" position="bottom">
                <van-datetime-picker
                v-model="currentStartDate"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="startDateConfirm"
                @cancel="startDateShow = false"
                />
            </van-popup>
        <!-- 结束日期 -->
        <van-field label="计划结束日期" @click="(isAddMode || !canOnlyModParticipator) ? endDateShow = true:''" readonly clickable :disabled="!isAddMode && canOnlyModParticipator">
            <template #input>
                <span>{{projectDetail.planEndDate}}</span>
            </template>
        </van-field>
            <van-popup v-model="endDateShow" position="bottom">
                <van-datetime-picker
                v-model="currentEndDate"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="endDateConfirm"
                @cancel="endDateShow = false"
                />
            </van-popup>
        <!-- 自定义维度 -->
        <van-field
            v-if="yonghuUser.customDegreeActive == 1 && user.timeType.customDegreeWithPro != 0"
            :label="yonghuUser.customDegreeName"
            :disabled="!isAddMode && canOnlyModParticipator"
            @click="(!isAddMode && !canOnlyModParticipator) || isAddMode ? customDegreeShow = true : ''"
            readonly
            clickable>
            <template #input>
                <span>{{ auseListNames }}</span>
            </template>
        </van-field>
            <van-popup v-model="customDegreeShow" position="bottom" :style="{ height: '80%' }">
                <div style="padding: 10px; font-weight: bold; font-size: 16px;">{{ yonghuUser.customDegreeName }}</div>
                <div style="minHeight:300px;">
                    <van-checkbox class="userCheckbox" v-for="(item) in ause" :key="item.id" v-model="item.isChecked">{{item.name}}</van-checkbox>
                    <van-button style="width:100%;position: -webkit-sticky;position: sticky;bottom: 0;" @click="customDegreeConfirm();customDegreeShow=false">确定</van-button>
                </div>
            </van-popup>
        </van-form>


        <div class="form_btn" style="position: fixed; bottom: 0px; width: 100%">
            <div style="padding: 0 0 10px 0; background: #fff;">
                <van-button square block type="info" @click="submitProject" style="width: 100%">保存</van-button>
                <van-button v-if="!isAddMode" square block type="danger" :disabled="canOnlyModParticipator" @click="deleteProject()" style="width: 100%; margin-top: 8px">删除</van-button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            user: JSON.parse(localStorage.userInfo),
            isAddMode: this.$route.query.mode === 'add',
            projectId: this.$route.query.mode === 'add' ? null : JSON.parse(sessionStorage.projectId),
            minDate: new Date(2023,0,1),
            maxDate: new Date(2029,11,31),
            projectDetail: {
                projectCode: '',
                projectName: '',
                projectDesc: '',
                isPublic: 0,
                userNames: '',
                userId: [],
                inchargerName: '',
                inchargerId: null,
                planStartDate: '',
                planEndDate: '',
                auditorList: [],
                auditUserIds: [],
                category: null,
                categoryName: '',
                projectMainId: null,
                projectMainName: '',
                level: null,
                levelLabel: '',
            },
            editCodeAndName: false,

            // 自定义维度
            ause: [],
            auseList: [],
            yonghuUser: {},
            customDegreeShow: false,

            mainProjectList: [],
            mainProjectShow: false,
            categoryList: [],
            categoryShow: false,
            publicList: ['正式项目','非项目'],
            publicShow: false,
            levelList: [],
            levelShow: false,
            userName: null,
            allUserList: [],
            userList: [],
            userNamesShow: false,
            inchargerList: [],
            inchargerShow: false,
            currentStartDate: new Date(),
            startDateShow: false,
            currentEndDate: new Date(),
            endDateShow: false,
            dailyUserList: [],
            dailyReviewFlg: false,
            editProjectMan: false,
            onSearchTime: null,
            canOnlyModParticipator: this.$route.query.canOnlyModParticipator==='1'?true:false,
        }
    },
    computed: {
        auseListNames() {
            return this.ause
                .filter(item => item.isChecked)
                .map(item => item.name)
                .join(',');
        }
    },
    mounted() {
        // 获取自定义维度配置和选项
        this.getCompanyTimeSetting()
        this.getCustomDegreeList()
        if (this.isAddMode) {
            // 新增模式：初始化数据，直接获取用户列表等基础数据
            this.editCodeAndName = true
            this.editProjectMan = true
            this.getUserList()
            if(this.user.timeType.mainProjectState == '1'){
                this.getMainProjectList()
            }else{
                this.getCategoryList()
            }
            if(this.user.timeType.projectLevelState == 1){
                this.getLevelList()
            }else{
                this.levelList = [
                    {label: '正常' ,id: 1},
                    {label: '紧急' ,id: 2},
                    {label: '重要' ,id: 3},
                    {label: '重要且紧急' ,id: 4},
                ]
            }
        } else {
            // 编辑模式：获取项目详情
            this.getProjectDetail()
            if(this.user.timeType.mainProjectState == '1'){
                this.getMainProjectList()
            }else{
                this.getCategoryList()
            }
        }
    },
    methods: {
        back() {
            history.back();
        },
        formatDate(date) {
            let mon = date.getMonth() + 1
            return `${date.getFullYear()}-${mon<10?'0'+mon:mon}-${date.getDate()<10?'0'+date.getDate():date.getDate()}`;
        },
        test(){
            console.log(this.projectDetail);
        },

        mainProjectConfirm(value,key){
            this.projectDetail.projectMainId = value.id
            this.projectDetail.projectMainName = value.name
            this.mainProjectShow = false
        },
        categoryConfirm(value,key){
            this.projectDetail.category = value.id
            this.projectDetail.categoryName = value.name
            this.categoryShow = false
        },
        publicConfirm(value,key){
            this.projectDetail.isPublic = key
            this.publicShow = false
        },
        levelConfirm(value,key){
            this.projectDetail.level = value.id
            this.projectDetail.levelLabel = value.label
            this.levelShow = false
        },
        onSearch(val) {
            if (this.user.userNameNeedTranslate != '1') {
                // 普通模式：本地过滤
                this.userList = [];
                this.allUserList.forEach(u => {
                    if (u.name.startsWith(val)) {
                        this.userList.push(u);
                    }
                });
            } else {
                // 企业微信翻译模式：防抖后调用后端接口搜索
                if (this.onSearchTime != null) {
                    clearTimeout(this.onSearchTime);
                }
                var that = this;
                this.onSearchTime = setTimeout(() => {
                    that.getOnSearch(val);
                }, 500);
            }
        },
        getOnSearch(val) {
            this.$axios.post('/user/getEmployeeList', {
                departmentId: -1,
                pageIndex: 1,
                pageSize: 200,
                keyword: val,
                status: 1,
                roleId: '',
                cursor: '',
                onlyDirect: 0,
            })
            .then(res => {
                if (res.code == 'ok') {
                    let list = res.data.records;
                    list = list.filter(user=>user.isActive==1);
                    list.forEach(u => {
                        let found = this.allUserList.find(a => a.id == u.id);
                        if (found) {
                            // 将 allUserList 中已有的勾选状态同步到搜索结果
                            u.isChecked = found.isChecked;
                        } else {
                            u.isChecked = false;
                            this.allUserList.push(u);
                        }
                    });
                    this.userList = list;
                } else {
                    this.$toast.fail('搜索失败');
                }
            }).catch(err => { this.$toast.clear(); console.log(err); });
        },
        userNamesConfirm(){
            let that = this;
            // 先把当前 userList 中的勾选状态写回 allUserList 对应对象，解决搜索后勾选状态不同步的问题
            this.userList.forEach(u => {
                let found = this.allUserList.find(a => a.id == u.id);
                if (found) {
                    found.isChecked = u.isChecked;
                }
            });
            that.inchargerList = [];
            that.projectDetail.userId = [];
            let userNames = ''
            this.allUserList.filter(u=>u.isChecked).forEach(u=>{
                userNames+=(u.name+',');
                that.projectDetail.userId.push(u.id);
                that.inchargerList.push(u);
            });
            if (userNames.length > 0) {
                userNames = userNames.substring(0, userNames.length-1);
            }
            this.$set(this.projectDetail,'userNames',userNames)
            this.integrationreAuidType()
        },
        auditorNameConfirm() {
            let auditorIdList = []
            let auditorList = []
            this.dailyUserList.filter(u=>u.isChecked).forEach(u=>{
                auditorIdList.push(u.id)
                let obj = {}
                obj.auditorName = u.name
                obj.auditorId = u.id
                auditorList.push(obj)
            });
            this.projectDetail.auditUserIds = auditorIdList
            this.projectDetail.auditorList = auditorList
        },
        integrationreAuidType() {
            this.dailyUserList = []
            this.allUserList.filter(u=>u.isChecked).forEach(u=>{
                let obj = {}
                obj.name = u.name
                obj.id = u.id
                obj.isChecked = false
                this.dailyUserList.push(obj)
            });
            let list = this.dailyUserList
            for(var i in list) {
                let length = this.projectDetail.auditorList.filter(u => u.auditorId == list[i].id).length
                if(length){
                    list[i].isChecked = true
                }else{
                    list[i].isChecked = false
                }
            }
        },
        inchargerConfirm(value,key){
            this.projectDetail.inchargerId = value.id
            this.projectDetail.inchargerName = value.name
            this.inchargerShow = false
        },
        startDateConfirm(value){
            this.currentStartDate = value
            this.$set(this.projectDetail, 'planStartDate', this.formatDate(value));
            this.startDateShow = false
        },
        endDateConfirm(value){
            this.currentEndDate = value
            this.$set(this.projectDetail, 'planEndDate', this.formatDate(value));
            this.endDateShow = false
        },


        submitProject(){
            this.$refs.projectSubmit.validate().then(()=>{
                let formData = new FormData();
                if (!this.isAddMode) {
                    formData.append("id", this.projectDetail.id);
                }
                formData.append("name", this.projectDetail.projectName);
                formData.append("code", this.projectDetail.projectCode ? this.projectDetail.projectCode : '');
                if(this.projectDetail.projectMainId && this.user.timeType.mainProjectState == '1') {
                    formData.append("projectMainId", this.projectDetail.projectMainId);
                }
                if(this.projectDetail.category) {
                    formData.append("category", this.projectDetail.category);
                }
                formData.append("projectDesc", this.projectDetail.projectDesc ? this.projectDetail.projectDesc : '');
                formData.append("isPublic", this.projectDetail.isPublic != null ? this.projectDetail.isPublic : 0);
                if(this.projectDetail.userId && this.projectDetail.userId.length != 0 && this.projectDetail.isPublic == 0) {
                    for(let i in this.projectDetail.userId) {
                        formData.append("userId", this.projectDetail.userId[i]);
                    }
                }
                if(this.projectDetail.inchargerId) {
                    formData.append("inchargerId", this.projectDetail.inchargerId);
                }
                if(this.projectDetail.planStartDate) {
                    formData.append("planStartDate", this.projectDetail.planStartDate);
                }
                if(this.projectDetail.planEndDate) {
                    formData.append("planEndDate", this.projectDetail.planEndDate);
                }
                if (this.projectDetail.auditUserIds && this.projectDetail.auditUserIds.length > 0) {
                    formData.append("auditUserIds", JSON.stringify(this.projectDetail.auditUserIds));
                }
                // 自定义维度
                let listId = []
                let listName = []
                for (let i in this.auseList) {
                    for (let j in this.ause) {
                        if (this.auseList[i] == this.ause[j].id) {
                            listId.push(this.ause[j].id)
                            listName.push(this.ause[j].name)
                            break
                        }
                    }
                }
                formData.append("associateDegrees", listId.toString())
                formData.append("associateDegreeNames", listName.toString())
                
                this.$axios.post("/project/editProject", formData)
                .then(res => {
                    if(res.code == "ok") {
                        this.$toast.success(this.isAddMode ? '新增成功' : '修改成功')
                        this.back()
                    } else {
                        this.$toast.fail(res.msg || '操作失败');
                    }
                }).catch(err=> {this.$toast.clear();console.log(err)});
            }).catch(()=>{return})
        },
        deleteProject(){
            this.$dialog.confirm({
                    title: '删除项目',
                    message: '确定要删除项目'+this.projectDetail.projectName+'吗?'
                }).then(() => {
                    const toast = this.$toast.loading({
                        forbidClick: true,
                        duration: 0
                    });
                    this.$axios.post("/project/deleteProject", {id: this.projectDetail.id})
                    .then(res => {
                        if(res.code == "ok") {
                            this.$toast.clear();
                            this.$toast.success('删除成功');
                            this.$router.push('/project');
                        } else if(res.code == 'reconfirm'){
                            this.$toast.clear();
                            this.forceDelete(res.msg)
                        } else {
                            this.$toast.clear();
                            this.$toast.fail(res.msg);
                        }
                    }).catch(err=> {this.$toast.clear();});
                }).catch(() => {});
        },
        forceDelete(msg){
            this.$dialog.confirm({
                    title: '删除项目',
                    message: msg
                }).then(() => {
                    const toast = this.$toast.loading({
                        forbidClick: true,
                        duration: 0
                    });
                    this.$axios.post("/project/deleteProject", {id: this.projectDetail.id, force: 1})
                    .then(res => {
                        if(res.code == "ok") {
                            this.$toast.clear();
                            this.$toast.success('删除成功');
                            this.back();
                        } else {
                            this.$toast.clear();
                            this.$toast.fail(res.msg);
                        }
                    }).catch(err=> {this.$toast.clear();});
                }).catch(() => {});
        },
        

        getProjectDetail(){
            console.log('发起了请求')
            this.$axios.post("/project/detail", {id: this.projectId})
            .then(res => {
                if(res.code == "ok") {
                    console.log('成功')
                    this.projectDetail = res.data
                    if (!this.projectDetail.auditorList) {
                        this.projectDetail.auditorList = []
                    }
                    let userNames = ''
                    let userId = []
                    for(let i in this.user.functionList){
                        if(this.user.functionList[i].name == '编辑负责项目编码和名称' || this.user.functionList[i].name == '管理全部项目'){
                            this.editCodeAndName = true
                        }
                        if(this.user.functionList[i].name == '管理全部项目' || this.user.id == res.data.creatorId){
                            this.editProjectMan = true
                        }
                    }

                    for(let i in res.data.participationList){
                        if(res.data.participationList[i].id && res.data.participationList[i].id != 'null'){
                            userNames += res.data.participationList[i].name + ','
                            userId.push(res.data.participationList[i].id)
                            this.inchargerList.push(res.data.participationList[i])
                        }
                    }
                    this.$set(this.projectDetail,'userNames',userNames ? userNames.substring(0,userNames.length - 1) : '')
                    this.$set(this.projectDetail,'userId',userId)
                    if(res.data.planStartDate){
                        this.currentStartDate = new Date(res.data.planStartDate)
                    }
                    if(res.data.planEndDate){
                        this.currentEndDate = new Date(res.data.planEndDate)
                    }
                    this.getUserList()
                    if(this.user.timeType.projectLevelState == 1){
                        this.getLevelList()
                    }else{
                        this.levelList = [
                            {label: '正常' ,id: 1},
                            {label: '紧急' ,id: 2},
                            {label: '重要' ,id: 3},
                            {label: '重要且紧急' ,id: 4},
                        ]
                        this.projectDetail.levelLabel = this.levelList[this.projectDetail.level - 1] ? this.levelList[this.projectDetail.level - 1].label : ''
                    }

                    // 初始化自定义维度选中状态
                    if (res.data.associateDegrees && res.data.associateDegrees != 'null' && res.data.associateDegrees != '') {
                        let spli = res.data.associateDegrees.split(',')
                        this.auseList = spli.map(id => +id)
                    } else {
                        this.auseList = []
                    }
                    // 如果 ause 已加载完毕，立即同步勾选状态
                    if (this.ause.length > 0) {
                        this.syncAuseChecked()
                    }

                    if(this.user.id == res.data.creatorId){
                        this.editCodeAndName = true
                        return
                    }
                } else {
                    this.$toast.fail('获取失败');
                }
            }).catch(err=> {this.$toast.clear();console.log(err)});
        },
        getMainProjectList(){
            this.$axios.post("/project-main/list", {})
            .then(res => {
                if(res.code == "ok") {
                    this.mainProjectList = res.data
                } else {
                    this.$toast.fail('获取失败');
                }
            }).catch(err=> {this.$toast.clear();console.log(err)});
        },
        getCategoryList(){
            this.$axios.get("/project-category/list", {})
            .then(res => {
                if(res.code == "ok") {
                    this.categoryList = res.data
                } else {
                    this.$toast.fail('获取失败');
                }
            }).catch(err=> {this.$toast.clear();console.log(err)});
        },
        getLevelList(){
            this.$axios.get("/project-level/list", {})
            .then(res => {
                if(res.code == "ok") {
                    this.levelList = res.data
                    if (!this.isAddMode) {
                        let list = this.levelList.filter(u => u.id == this.projectDetail.level)
                        this.projectDetail.levelLabel = list.length != 0 ? list[0].label : ''
                    }
                } else {
                    this.$toast.fail('获取失败');
                }
            }).catch(err=> {this.$toast.clear();console.log(err)});
        },
        getUserList(){
            this.$axios.post("/user/getEmployeeList", {departmentId: -1,pageIndex: 1,pageSize: -1, status: 1})
            .then(res => {
                if(res.code == "ok") {
                    let list = res.data.records
                    for (let i in list) {
                        if (this.isAddMode) {
                            list[i].isChecked = false
                        } else {
                            let length = this.projectDetail.participationList.filter(u => u.id == list[i].id).length
                            if(length){
                                list[i].isChecked = true
                            }else{
                                list[i].isChecked = false
                            }
                        }
                    }
                    this.allUserList = list;
                    this.userList = list;
                    // 新增模式下初始化 inchargerList 为全部用户
                    if (this.isAddMode) {
                        this.inchargerList = list;
                    }
                    this.integrationreAuidType()
                } else {
                    this.$toast.fail('获取失败');
                }
            }).catch(err=> {this.$toast.clear();console.log(err)});
        },
        // 获取公司时间设置（含自定义维度配置）
        getCompanyTimeSetting() {
            this.$axios.post("/time-type/getCompanyTimeSetting", { companyId: this.user.companyId })
            .then(res => {
                if(res.code == "ok") {
                    this.yonghuUser = res.data
                }
            }).catch(err => { console.log(err); });
        },
        // 获取自定义维度选项列表
        getCustomDegreeList() {
            this.$axios.post("/report-extra-degree/getAll", {})
            .then(res => {
                if(res.code == "ok") {
                    let list = res.data || []
                    list.forEach(item => {
                        this.$set(item, 'isChecked', false)
                    })
                    this.ause = list
                    // 如果已有选中的 auseList（编辑模式下先加载了项目详情），同步勾选状态
                    if (this.auseList.length > 0) {
                        this.syncAuseChecked()
                    }
                }
            }).catch(err => { console.log(err); });
        },
        // 将 auseList（id数组）同步到 ause 的 isChecked 状态
        syncAuseChecked() {
            this.ause.forEach(item => {
                item.isChecked = this.auseList.indexOf(item.id) !== -1
            })
        },
        // 确认自定义维度选择
        customDegreeConfirm() {
            this.auseList = this.ause.filter(item => item.isChecked).map(item => item.id)
        },
    },
}
</script>

<style lang="less" scoped>
.content{
    margin-top: 46px;
    overflow: auto;
    .userCheckbox {
        padding: 10px;
    }
}
</style>
